import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showBriefProductDescription, hideBriefProductDescription }
  from '../../../../appState/ducks/listingPageProducts';
import uiLocale from '../../../../utils/UILocale.js';

const productDescriptionTitleOpenedTranslation =
    uiLocale.getString('component.productlisting.closeLabel');
const productDescriptionTitleClosedTranslation =
    uiLocale.getString('component.productlisting.briefProductDescLabel');

class ProductBriefDescriptionSwitch extends PureComponent {
  constructor(props) {
    super(props);
    this.onBriefDescriptionClick = this.onBriefDescriptionClick.bind(this);
  }

  componentWillUnmount() {
    this.props.hideBriefProductDescription();
  }

  onBriefDescriptionClick() {
    if (this.props.briefDescriptionProductID === this.props.productID) {
      this.props.hideBriefProductDescription(null);
    } else {
      this.props.showBriefProductDescription(this.props.productID);
    }
  }

  render() {
    return (
      <div
        data-component="product-desc"
        onClick={this.onBriefDescriptionClick}
        className="product-desc"
        style={this.props.productDescHeight ? { height: this.props.productDescHeight } : undefined}
      >
        {this.props.briefDescriptionProductID !== this.props.productID
        ? (
          <div className="product-desc-toggle-closed">
            <i className="dcg-icon-caret-right" />
            <span
              className="product-desc-toggle-title"
              data-text="Brief product description"
            >
              {productDescriptionTitleClosedTranslation}
            </span>
            {this.props.withArrow && <span className="product-desc-arrow" />}
          </div>
          )
        : (
          <div className="product-desc-toggle-opened" style={{ display: 'block' }}>
            <i className="dcg-icon-caret-down" />
            <span className="product-desc-toggle-title">
              {productDescriptionTitleOpenedTranslation}
            </span>
            {this.props.withArrow && <span className="product-desc-arrow" />}
          </div>
          )
        }
      </div>
    );
  }
}

ProductBriefDescriptionSwitch.propTypes = {
  briefDescriptionProductID: PropTypes.string,
  hideBriefProductDescription: PropTypes.func,
  productID: PropTypes.string.isRequired,
  showBriefProductDescription: PropTypes.func,
  withArrow: PropTypes.bool,
  productDescHeight: PropTypes.number
};

ProductBriefDescriptionSwitch.defaultProps = {
  briefDescriptionProductID: null,
  hideBriefProductDescription: () => {},
  showBriefProductDescription: () => {},
  withArrow: false,
  // for dynamic sizing if used in Grid
  productDescHeight: undefined
};

const mapStateToProps = state => ({
  briefDescriptionProductID: state.listingPage.products.briefDescriptionProductID
});

const dispatchFunctions = {
  showBriefProductDescription,
  hideBriefProductDescription
};

export default connect(mapStateToProps, dispatchFunctions)(ProductBriefDescriptionSwitch);
